export default "__VITE_ASSET__wnRgE6HM__"